import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useContext } from 'react';
import cn from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import noop from '../../utils/noop';
import { SubscriptionPurchaseFTUEContext } from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import SubscriptionPurchaseFTUE from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUE';
import StageBackground from '../../DeviationBackground/StageBackground';
import Full from '../../DeviationViews/Full';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import { useMobileStage } from '../hooks/useMobileStage';
import Duperswiper from '../_partials/Duperswiper';
import ZoomModalFromImageSource from '../_partials/ZoomModalFromImageSource';
import styles from './MobileArtStage.scss';
const MOBILE_STAGE_MAX_HEIGHT = 411;
// precondition: the following Desktop DeviationTypes don't end up here:
//   POLL, STATUS, COMMISSION, TIER, JOURNAL, LITERATURE (they have their own ArtStages)
// that currently leaves:
//   UNKNOWN, IMAGE, FILM, PDF
const MobileSingleArtStage = ({ deviation, className, zoomedImageSource, isZoomed, onEnterZoomMode = noop, onExitZoomMode = noop })=>{
    const height_mobile_artstage = useFlag('height_mobile_artstage');
    const { contentSize, containerSize } = useMobileStage(deviation, height_mobile_artstage ? MOBILE_STAGE_MAX_HEIGHT : undefined);
    // polls and statuses put all their content into the art stage and thus need to be unlimited in height
    const noStageHeight = [
        DeviationTypes.POLL,
        DeviationTypes.STATUS
    ].includes(getDeviationType(deviation));
    const isSubscriptionPurchaseFTUEBeingShown = !!useContext(SubscriptionPurchaseFTUEContext);
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(className, styles['root'])
    }, /*#__PURE__*/ React.createElement(Duperswiper, {
        key: deviation.deviationId,
        deviation: deviation,
        height: noStageHeight ? 'auto' : containerSize === null || containerSize === void 0 ? void 0 : containerSize.height,
        width: containerSize === null || containerSize === void 0 ? void 0 : containerSize.width,
        isInZoomModal: isZoomed
    }, (dev)=>{
        var _zoomedImageSource_isPublished;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(StageBackground, {
            deviation: dev,
            height: containerSize === null || containerSize === void 0 ? void 0 : containerSize.height,
            width: containerSize === null || containerSize === void 0 ? void 0 : containerSize.width
        }), /*#__PURE__*/ React.createElement(Full, {
            deviation: dev,
            width: contentSize === null || contentSize === void 0 ? void 0 : contentSize.width,
            height: noStageHeight ? undefined : contentSize === null || contentSize === void 0 ? void 0 : contentSize.height,
            withoutZoomModal: true,
            isZoomed: isZoomed,
            onEnterZoomMode: onEnterZoomMode,
            onExitZoomMode: onExitZoomMode
        }), zoomedImageSource && /*#__PURE__*/ React.createElement(ZoomModalFromImageSource, _object_spread_props(_object_spread({
            source: zoomedImageSource,
            allowFullviewSrcsetForPngs: (_zoomedImageSource_isPublished = zoomedImageSource === null || zoomedImageSource === void 0 ? void 0 : zoomedImageSource.isPublished) !== null && _zoomedImageSource_isPublished !== void 0 ? _zoomedImageSource_isPublished : false
        }, contentSize), {
            isZoomed: isZoomed,
            onExitZoomMode: onExitZoomMode
        })), isSubscriptionPurchaseFTUEBeingShown && /*#__PURE__*/ React.createElement(SubscriptionPurchaseFTUE, null));
    }));
};
MobileSingleArtStage.displayName = 'MobileSingleArtStage';
export default MobileSingleArtStage;

//# sourceMappingURL=MobileSingleArtStage.js.map